import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
export default {
  props: ['module'],
  data: function data() {
    return {
      scriptSrc: null
    };
  },
  computed: {
    isFigma: function isFigma() {
      if (this.module.embed && this.module.embed.url) {
        var link = this.module.embed.url;
        if (link.match(/:\/\/(www\.)?figma.com\//)) return true;
      }
      return !!this.module.isFigma;
    },
    html: function html() {
      if (this.module.embed && this.module.embed.html) {
        var html = this.module.embed.html;

        // Toggle options
        html = useEmbedOptionsHtml(html, this.module);

        // Extract script
        var scriptHtml = /<script.*src="(.+?)".*><\/script>/;
        if (scriptHtml.test(html)) {
          var parts = scriptHtml.exec(html);
          this.scriptSrc = parts[1];
          return html.replace(scriptHtml, '');
        } else {
          return html;
        }
      }
      return null;
    }
  },
  watch: {
    scriptSrc: {
      immediate: true,
      handler: function handler(val, oldVal) {
        if (val) {
          var script = document.createElement('script');
          script.async = true;
          script.setAttribute('src', this.scriptSrc);
          this.$el.appendChild(script);
        }
      }
    }
  },
  mounted: function mounted() {
    this.loadInstagram();
  },
  methods: {
    loadInstagram: function loadInstagram() {
      var _this = this;
      this.$nextTick(function () {
        if (!_this.module.embed.provider_name) {
          var html = _this.module.embed.html;
          // Detect old instagram embed
          var insta = /instagram-media/;
          if (insta.test(html)) _this.module.embed.provider_name = 'instagram';
        }
        if (_this.module.embed && _this.module.embed.provider_name && _this.module.embed.provider_name.toLowerCase() == 'instagram' && window.instgrm) {
          window.instgrm.Embeds.process();
        }
      });
    }
  }
};